const aifJcamp1 = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (0.1.0)
##DATA TYPE=SORPTION-DESORPTION MEASUREMENT
##DATA CLASS=XYDATA
##ORIGIN=
##OWNER=
##XUNITS=p/p0
##YUNITS=ml/g
##OPERATOR=Volodymyr
##DATE=2020-04-30T00:00:00
##SERIAL=BEL 00218
##ADSORPTIVE=CH4
##TEMPERATURE=384.15
##AMOUNT=0.00980
##SAMPLE_CID=aus der BOX
##SAMPLE_MAT_ID=DUT-140(Cu)
##SOFTWARE=raw2aif
##SOFTWARE_VERSION=v004
##FIRSTX=0.000213204381723083
##LASTX=0.9634757722293498
##MINX=0.000213204381723083
##MAXX=0.9634757722293498
##MINY=10.631
##MAXY=1481.2
##NPOINTS=96
##FIRSTY=10.631
##XUNITS=p/p0
##YUNITS=ml/g
##XYDATA=(XY..XY)
0.000213204381723083, 10.631
0.0008993091878022303, 66.609
0.0016908121977696636, 120.28
0.002905260041448732, 170.14
0.004614526793644528, 214.69
0.008697226882463239, 282.5
0.012181979670383893, 322.52
0.016622915227474586, 360.27
0.022689233198460477, 401.55
0.024416263692884636, 412.09
0.030442119806572587, 445.23
0.03634757722293497, 475.88
0.037632487910786536, 482.6
0.04695253133326754, 528.34
0.049001282936938714, 538.13
0.05896378170334551, 588.18
0.06089213460969111, 598.56
0.06715878811803021, 632.29
0.0724217901904668, 664.8
0.0735468271982631, 673.66
0.12681338201914535, 551.43
0.13605052797789402, 552.89
0.14818908516727525, 554.89
0.16031777361097405, 557.43
0.17252541202013225, 559.16
0.1847034441922432, 560.83
0.19691108260140136, 562.66
0.20912858975624196, 563.62
0.22129675318267047, 565.09
0.2334353103720517, 566.49
0.24568242376393962, 568.2
0.2578111122076384, 569.8
0.26974242573768875, 571.86
0.2820388828579888, 573.23
0.29420704628441724, 574.73
0.3063456034737985, 576.8
0.3184742919174973, 577.93
0.33048455541300703, 580.66
0.34253429389124646, 583.42
0.3546728510806277, 586.22
0.3664363959340768, 590.5
0.37840718444685684, 595.32
0.3900621730977993, 602.39
0.4011052995164315, 612.81
0.4143294187308793, 644.21
0.425175170235863, 680.11
0.43460969110826014, 719.33
0.43827099575643935, 737.27
0.4470245731767492, 774.86
0.45003454060988846, 794.41
0.4586795618276917, 834.82
0.46289351623408664, 862.67
0.4716865686371262, 897.89
0.4746669298332182, 916.08
0.4841804006710747, 949.07
0.48683509325964675, 967.72
0.4977992697128195, 1006.3
0.5086055462350735, 1041.7
0.5107766702852068, 1051.9
0.5232310273364256, 1084.8
0.5350833909010165, 1108.9
0.5475377479522353, 1130.8
0.5602289548998323, 1151.2
0.5729596368301589, 1170.2
0.5835685384387644, 1182.7
0.5969900325668608, 1201.7
0.6076778841409257, 1215.4
0.6213362281654002, 1234.2
0.6324583045494918, 1246.5
0.6460376986085068, 1265.7
0.6567650251653014, 1277.2
0.6686568637126221, 1290.4
0.6803414586006118, 1305.8
0.6943649462153361, 1327.4
0.7055363663278398, 1338.5
0.7174676798578901, 1353.9
0.7297937432152374, 1364.5
0.7422875752491858, 1376.9
0.7547814072831344, 1386.7
0.767117339386164, 1395.1
0.7788019342741538, 1404.7
0.7906542978387447, 1415.0
0.8027040363169841, 1425.7
0.8154445869929933, 1433.9
0.827898944044212, 1442.2
0.8404322510608901, 1449.0
0.8528471331293792, 1454.4
0.8653409651633278, 1458.8
0.8776275535379454, 1462.7
0.8899240106582453, 1466.3
0.9024178426921937, 1469.2
0.9143886312049738, 1473.3
0.9270403631698411, 1473.8
0.9390506266653508, 1476.2
0.9511003651435903, 1479.6
0.9634757722293498, 1481.2
##END=$$ End of the data block

`;
export default aifJcamp1;
